import gql from 'graphql-tag';

import { HOME_PAGE_MARKETING_FRAGMENT } from '../fragments';

const queryName = 'homePageMarketing';

export const HOME_PAGE_MARKETING = {
  queryName,
  queryBody: gql`
    query ${queryName} {
      ${queryName} {
        ...homePageMarketing
      }
    }
    ${HOME_PAGE_MARKETING_FRAGMENT}
  `,
};
